import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getAuth } from '../../selectors/access/auth'
import getSaleTypesAll from '../../services/saleType/getSaleTypesAll'
import { showLoader, hideLoader } from '../../actions/common.js'
import messageModalActions from '../../actions/modals/messageModal'
import { fetchSaleTypeBySubtypeSuccess } from '../../actions/combos/combos'
import combosActionTypes from '../../constants/actions/combos/combos'
import { handleError } from '../errors/errorManager'
import { dossierSubTypes } from '../../constants/backendIds'

export function * fetchSaleTypeBySubtype ({ dossierSubTypeId, clearCombo }) {
  try {
    yield put(showLoader())
    const auth = yield select(getAuth)
    let combo = []
    if (dossierSubTypeId === dossierSubTypes.sale_vn || dossierSubTypeId === dossierSubTypes.sale_vo || !dossierSubTypeId && !clearCombo) {
      combo = yield call(getSaleTypesAll, dossierSubTypeId, auth.token)
    }
    yield put(fetchSaleTypeBySubtypeSuccess(combo))
  } catch (error) {
    const customHandler = function * () {
      yield put(messageModalActions.openErrorMessageModal('MESSAGES.FETCH_COMBO_ERROR'))
    }
    yield call(handleError, { error, customHandler })
  } finally {
    yield put(hideLoader())
  }
}

export function * watchFetchSaleTypeBySubtype () {
  yield takeLatest(combosActionTypes.FETCH_SALE_TYPE_BY_SUBTYPE, fetchSaleTypeBySubtype)
}
